module.exports = __webpack_public_path__ + "img/bg-carbon.9f738cfc.jpeg";